/// <reference types="google.maps" />

let isLoading = false;
let isLoaded = false;
let loadError = false;
const callbacks: Array<() => void> = [];

export const loadGoogleMaps = (callback: () => void): void => {
  // Se já carregou, executa callback imediatamente
  if (isLoaded && window.google && window.google.maps) {
    try {
      callback();
    } catch (error) {
      console.error("Erro ao executar callback do Google Maps:", error);
    }
    return;
  }

  // Se houve erro no carregamento, não tenta novamente
  if (loadError) {
    console.warn("Google Maps não pôde ser carregado anteriormente");
    return;
  }

  // Adiciona callback à fila
  callbacks.push(callback);

  // Se já está carregando, apenas aguarda
  if (isLoading) {
    return;
  }

  // Verifica se o script já existe no DOM
  const existingScript = document.querySelector(
    'script[src*="maps.googleapis.com"]',
  );

  if (existingScript) {
    // Aguarda um pouco para garantir que o Google Maps foi inicializado
    setTimeout(() => {
      if (window.google && window.google.maps) {
        isLoaded = true;
        executeCallbacks();
      } else {
        console.warn(
          "Script do Google Maps encontrado, mas API não inicializada",
        );
        // Tenta executar callbacks mesmo assim
        executeCallbacks();
      }
    }, 100);
    return;
  }

  // Verifica se a API key está definida
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    console.error("VITE_GOOGLE_MAPS_API_KEY não está definida");
    loadError = true;
    // Limpa callbacks sem executar
    callbacks.length = 0;
    return;
  }

  // Inicia carregamento
  isLoading = true;

  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,marker`;
  script.async = true;
  script.defer = true;

  script.onload = () => {
    isLoading = false;
    isLoaded = true;
    executeCallbacks();
  };

  script.onerror = (error) => {
    isLoading = false;
    loadError = true;
    console.error("Erro ao carregar Google Maps:", error);
    // Limpa callbacks sem executar para evitar erros em cascata
    callbacks.length = 0;
  };

  document.head.appendChild(script);
};

const executeCallbacks = () => {
  while (callbacks.length > 0) {
    const callback = callbacks.shift();
    if (callback) {
      try {
        callback();
      } catch (error) {
        console.error("Erro ao executar callback:", error);
      }
    }
  }
};
